import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { IconButtonType } from '../../model/button';
import { Color } from '../../model/color';
import { IconSize } from '../../model';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'spx-icon-button',
  templateUrl: './icon-button.component.html',
  imports: [CommonModule, IconComponent, MatButtonModule],
})
export class IconButtonComponent {
  /**
   * Color for Icon Button
   */
  @Input() color!: Color;

  /**
   * Disabled state
   */
  @Input() disabled = false;

  /**
   * Type of the icon button
   */
  @Input() type!: IconButtonType;

  /**
   * File path to icon file
   */
  @Input() iconFilePath!: string;

  /**
   * Name of the registered Icon
   */
  @Input() iconName!: string;

  /**
   * Namespace in which the icon is registered
   */
  @Input() iconNamespace!: string;

  /**
   * Material icon font class, which is used by the spx-icon
   */
  @Input() fontSetClass!: string;

  /**
   * Size of the icon
   */
  @Input() size: IconSize = 'md';

  /**
   * Custom CSS class to add to the button
   */
  @Input() buttonClass?: string;
}
